import {fetchWithAuth} from '../util/fetch';
import {ReferenceEndpointURL} from '../constants';
import {actionFactory} from '../util/redux-helpers';

export const ACTIONS = {
  CountriesLoadInProgress: 'REFERENCE_LOADING_COUNTRIES',
  CountriesLoadFailed: 'REFERENCE_COUNTRIES_LOAD_FAILED',
  CountriesLoadCompleted: 'REFERENCE_COUNTRIES_LOADED'
};

export const CountriesLoadingInProgress = actionFactory(ACTIONS.CountriesLoadInProgress);
export const CountriesLoadingCompleted = actionFactory(ACTIONS.CountriesLoadCompleted);
export const CountriesLoadingFailed = actionFactory(ACTIONS.CountriesLoadingFailed);

export function LoadCountriesEpic() {
  return async (dispatch) => {
    dispatch(CountriesLoadingInProgress());
    const countriesResponse = await fetchWithAuth(`${ReferenceEndpointURL}/countries`);
    if (countriesResponse.status === 200){
      const countriesData = await countriesResponse.json();
      dispatch(CountriesLoadingCompleted(countriesData));
    } else {
      dispatch(CountriesLoadingFailed());
    }
    return;
  }
}



// WEBPACK FOOTER //
// ./src/actions/reference.actions.js